// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3SN9b","question":"Question_question__14Ljw","description":"Question_description__dVke5"};